// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { filterStyles } from '@insite/content-library/Widgets/MyLists/MyListsFilter';
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import { css } from "styled-components";

filterStyles.container = {
    css: css`
            padding-top: 20px;
            padding-bottom: 15px;
            
            ${GridItemStyle} > div {
                width: 100%;
                padding: 0;
            }
        `,
}

filterStyles.autocompleteGridItem = {
    width: [12, 12, 3, 3, 4],
}

filterStyles.fromGridItem = { width: [12, 6, 3, 3, 2] }
filterStyles.toGridItem = { width: [12, 6, 3, 3, 2], }

filterStyles.toDate = {
    cssOverrides: {
        formField: css`
                width: 100%;
                margin-top: 21px;
            `,
        },
}

